import React from 'react'
import TitleChnage from '../../Hook/TitleChnage'
import imageOne from '../../resource/aboutus/compliments/F1.png'
import imageTwo from '../../resource/aboutus/compliments/5.png'
import imageThree from '../../resource/aboutus/compliments/f3.png'
import imageFour from '../../resource/aboutus/compliments/f4.png'

import imageFive from '../../resource/aboutus/compliments/one.png';
import imageSix from '../../resource/aboutus/compliments/2.2.png';
import imageSeven from '../../resource/aboutus/compliments/3.3.png';


const Compliment = () => {

    TitleChnage("Complimets")

    return (
        <div className="compliment-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>

            <h1 className='font-main dark-gold p-6 p-4'>Compliments</h1>

            <div className="test">
                <div className="p-block h5 text-bold">
                    <p >With great respect to elders dear,</p>
                    <p>We humbly ask, please stay near.</p>
                    <p>Kindness and wisdom, together they share,</p>
                    <p>Their thoughts and advice, given with care.</p>

                    <p className='mt-5'>Proud we are to store here,</p>
                    <p>The teachings that help us persevere.</p>
                    <p>Sadhu! We bow with hearts sincere,</p>
                    <p>Our teachers, whom we hold so dear.</p>
                </div>
               
            </div>


            <div className="compliment-box p-5 mt-4">
            <h3 className='mt-4 h4'>Mahanayake of the Ramanna Maha Nikaya</h3>
            <h1 className='mt-4 font-second'>Most Venerable Makulewe Wimala Maha Thero</h1>

                <div className="compliment-one mt-6">
                    <div className="c-image" >
                        <img src={imageFive} alt="image one" width={600} />
                    </div>
                    <div className="c-details">
                        <p className="font-p">The Bhaddeka Vihari Monastery and Meditation Centre, located in Ripplebrook, Melbourne, Australia, was inaugurated by the Most Venerable Wimalagnana Thero in 2019 as a meditation centre for the Sri Lankan community living in Victoria, Australia. Under his guidance, and with the support of dedicated volunteer organisers, the centre offers daily and weekly Dhamma sermons and discussions, residential meditation retreats, Katina ceremonies, and Arama poojas. These activities are not only for the Sri Lankan community but are also open to the wider Australian population, paving the way for greater fulfilment and the accumulation of meritorious deeds.</p>
                        <p className="font-p mt-4">Last year, we had the privilege of attending the Arama Pooja held at the Bhaddeka Vihari Monastery. It was a deeply meaningful experience, and we were fortunate to witness this meritorious event unfold, gaining a profound understanding of its significance.
                        </p>
                    </div>
                </div>

                <p className='font-p mt-5'>The Most Venerable Mahopadya Durandara Kadawedduwa Jinawansha Maha Thero, a Royal Pandit and founder of the renowned Sri Kalyani Yogashrama Sansthawa of Sri Lanka under the Ramaghanna Maha Nikaya, initiated Wimalagnana Thero into the monastic life and bestowed upon him the Upasampada. Subsequently, under the guidance of the Most Venerable Na Uyana Ariyadhamma Maha Thero, Wimalagnana Thero received extensive training to fulfil his monastic obligations.
                </p>
                <p className='font-p mt-5'>As a Dhamma advisor migrating to Australia, Wimalagnana Thero embodied the noble words of the Buddha: “Caratha bhikkhave carikaṃ bahujana hithaya sukhaya attaya hithaya deva-manussānaṃ.” (Go, monks, for the benefit of many, for the happiness of many, for the welfare of many, for the benefit of gods and humans.) As expressed in the Buddhanusasanaya (the spread of the Buddha’s teachings through travel as a Sangha member).</p>
                <p className="font-p mt-5">In Australia, the Most Venerable Wagodapola Wimalagnana Thero established a monastery and meditation centre in line with the Theravada Buddhist tradition, aiming to promote the spiritual well-being of both the Sri Lankan community and the wider Australian society.</p>
                <p className='font-p mt-5'>We offer our blessings and sincere wishes for the continued protection of the Triple Gem upon all the supporting community members and Sangha members at the centre. May they be endowed with strength, courage, dedication, and the willingness to continue this noble work for the benefit of the Sasana.</p>



                <div className="bottom-box mt-4">
                <img src={imageThree} alt="bottom-image" width={400} />
            </div>
            

            </div>



            <div className="compliment-box p-4 mt-6">
            <h3 className='mt-4 h4'>Chief Spiritual Advisor</h3>
            <h3 className='mt-4 h4'>of Sri Kalyana Yogashrama Samstha,</h3>
            <h3 className="mt-4 h4">Most Venerable</h3>
            <h1 className='mt-4 font-second'>Pahalavitiyala Jananandha Maha Thero</h1>

                <div className="compliment-one mt-6">
                    <div className="c-image">
                    <img src={imageSix} alt="image one" width={600} />
                    </div>
                    <div className="c-details">
                    <p className='font-p mt-5'>“Paramaya Poojaya – Dhammanudhammappatipanna Viharissama Samichipatipanna Anudhammacharino” 
                    </p>
                        <p className="font-p mt-4">A true disciple of the Buddha is one whose spiritual practice transcends mere
Aamisa Pooja (offerings), reflecting a profound commitment to living and embodying the teachings
of the Dhamma through mindful and disciplined practice. Such an individual exemplifies the path of
Dhammanu-Dhamma Prathipatthi (practicing according to the Dhamma) through unwavering
commitment and steadfast devotion to the teachings of Lord Buddha. His spiritual journey is
characterized by aligning his life with Anudhammadhari prathipadawa and engaging deeply in
Prathipatthi pooja with mindfulness, loyalty, and dedication. </p>
                       
                    </div>
                    
                </div>
                <p className="font-p mt-4">Most Venerable Wimalagnana Maha Thero entered monastic life at the young age embarking on a lifelong journey of spiritual development and service. From the early stages of his monastic journey through to
Upasampada (ordination as a fully qualified monk), he was fortunate to receive guidance and
instruction from a distinguished group of revered teachers, including Most Venerable Royal Pandit
Mathara Ghanarama Maha Thero, Most Venerable Getamanne Wimalawansha Maha Thero,
Most Venerable Kadawedduwa Jinawansha Maha Thero, Most Venerable Dewegoda
Mangala Siri Thero, Most Venerable Na Uyana Ariyadhamma Maha Thero. In 2017, Most
Venerable Wimalagnana Maha Thero founded the Bhaddeka Vihari Monastery and
Meditation Centre in Melbourne, Victoria adhering to the ancient forest tradition. The
Monastery serves as a spiritual refuge for the Sri Lankan community, providing
opportunities for mindfulness practice, Dhamma discussions, and residential meditation
retreats.
</p>
<p className="font-p mt-4">“ Dhammosadha Saman Naththi – Ethan piwatha bikhewo ! “ - There is no remedy greater
than the Dhamma to heal the ill mind. One can drink the medicine of Dhamma to cure the
suffering caused by mental afflictions. Defilements such as raga (attachment) can weaken
the mind, but only the medicine of Dhamma can bring about true healing. When the mind
becomes clouded by raga, through the cultivation of Samadhi (meditative concentration),
one can eradicate these defilements at their root.
</p>
<p className="font-p mt-4">The founder of the Bhaddeka Vihari Monastery and Meditation Centre, Most Venerable
Wimalagnana Maha Thero, has dedicated his life for others to create a haven for learning
the Dhamma and practicing mindfulness meditation. With deep respect and gratitude, I pray
that Most Venerable Wagodapola Wimalagnana Thero may be granted the strength,
courage, dedication, and willpower to continue this noble work at the Bhaddeka Vihari
Monastery. I solemnly offer my prayers and best wishes for his continued health, happiness,
and longevity.</p>

                <div className="bottom-box mt-4">
                <img src={imageFour} alt="bottom-image" width={400} />
            </div>

            </div>



            <div className="compliment-box p-4 mt-6">
            <h3 className='mt-4 h4'>The most venerable</h3>
            <h1 className='mt-4 font-second'>Kahagolle Somawansa Thero</h1>
            <p>(The advisor, instructor and the cheif incumbent of Galduwa Monastery)</p>

                <div className="compliment-one mt-6">
                    <div className="c-image">
                    <img src={imageSeven} alt="image one" width={600} />
                    </div>
                    <div className="c-details">
                        <p className="font-p">The Bhaddeka Vihari Monastery and Meditation Centre, located in Ripplebrook, Melbourne, Australia, was opened in 2017 by Most Venerable Wagodapola Wimalagnana Thero. It is a tributary of the renowned Sri Kalyani Yogashrama Sansthawa in Sri Lanka and belongs to the Ramaghanna Maha Nikaya. With the utmost respect and admiration, I acknowledge Most Venerable Wimalagnana Thero’s dedication and significant contributions to the development of the centre. His tireless efforts are solely dedicated to the preservation of the Sangha Sasanaya in accordance with the Vinaya.</p>
                        <p className="font-p mt-4">I commend Most Venerable Wimalagnana Thero for establishing an environment where ten Sangha members can comfortably continue their monastic practices and cultivate the essential threefold path: Sīla (moral conduct), Samādhi (concentration), and Paññā (wisdom).</p>
                    </div>
                </div>
                <p className='font-p mt-5'>The practice of Pindapāta (alms-round), which is considered a rare occurrence in modern society, continues at the centre in Australia. This practice is praised by the local community, who come to witness it daily. The daily Buddha Pūja (worship) is conducted with great honor, and it has earned the deep appreciation of all who attend.</p>
                <p className='font-p mt-5'>It is with great appreciation that we at the Sri Kalyani Yogashrama Sansthawa, Sri Lanka, acknowledge the Centre’s development of meditation kutis for the Sangha, enabling them to continue their monastic work and duties. Additionally, the fully functional Meditation Hall and residential facilities for the lay community allow them to comfortably practice meditation and attend Dhamma sermons. According to the constitution of the Sri Kalyani Yogashrama Sansthawa, contributing to the Sasanaya enhances qualities such as Sīla for both the Sangha and the laity, which is undoubtedly beneficial for all.</p>
                <p className="font-p mt-5">Most Venerable Wimalagnana Maha Thero entered the monastic life at the tender age of 14 as a Samanera (novice monk). He was guided by renowned senior monks such as Most Venerable Mathara Ghanarama Maha Thero, Most Venerable Getamanne Wimalawansha Maha Thero, Most Venerable Kadawedduwa Jinawansha Maha Thero, Most Venerable Dewegoda Mangala Siri Maha Thero, and Most Venerable Na Uyana Ariyadhamma Maha Thero, who contributed greatly to his profound knowledge of both the Dhamma and Vinaya.</p>
                <p className='font-p mt-5'>Under the leadership of Most Venerable Wimalagnana Maha Thero, the Thanjan Thenna Bhaddheka Vihari Monastery in Balangoda, Sri Lanka, was established in 2013. Currently, 60 members of the Sangha reside there, practicing deep meditation and studying the Dhamma.</p>
                <p className="font-p">Every year, under the invitation of Most Venerable Wimalagnana Maha Thero, Most Venerable Maha Nayake Thero and other senior Sangha members are invited to the Bhaddeka Vihari Monastery in Australia to attend the Arama Pūja ceremony, which is supported by a large number of devoted community members. This event is deeply appreciated by all.</p>
                <p className="font-p mt-5">With great Metta, I pray that Most Venerable Wagodapola Wimalagnana Thero continues his outstanding work at the Bhaddeka Vihari Monastery in Ripplebrook, Victoria, Australia, with strength, courage, dedication, and wisdom. I wish him a long and healthy life.</p>

                <div className="bottom-box mt-4">
                <img src={imageTwo} alt="bottom-image" width={400} />
            </div>

            </div>


        </div>
    )
}

export default Compliment